export default __webpack_public_path__ + "static/media/ic-sms.7ee38037.svg";